<template>
  <div
    data-testid="radio-row"
    :role="multiple ? 'checkbox' : 'radio'"
    :aria-checked="selected ? 'true' : 'false'"
    :aria-disabled="disabled ? 'true' : 'false'"
    :tabindex="disabled ? -1 : 0"
    class="flex items-center w-full gap-[14px] bg-white px-6 py-4 min-h-[70px] text-left outline-none focus-visible:ring-1 focus-visible:ring-brand-500"
    :class="[
      showDivider ? 'border-b border-gray-brand-300' : '',
      disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:bg-gray-brand-100'
    ]"
    @click="select"
    @keydown.enter.prevent="select"
    @keydown.space.prevent="select"
  >
    <span
      data-testid="radio-row-glyph"
      class="flex-none flex items-center justify-center w-5 h-5 border-2"
      :class="[
        multiple ? 'rounded-md' : 'rounded-full',
        selected ? 'border-brand-500' : 'border-gray-brand-400',
        multiple && selected ? 'bg-brand-500' : 'bg-white'
      ]"
    >
      <svg
        v-if="multiple && selected"
        data-testid="radio-row-check"
        class="w-3 h-3 text-white"
        viewBox="0 0 12 12"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M2 6.5L4.75 9.25L10 3.5" />
      </svg>
      <span v-else-if="selected" data-testid="radio-row-dot" class="block w-2.5 h-2.5 rounded-full bg-brand-500" />
    </span>

    <span class="flex-grow min-w-0">
      <span data-testid="radio-row-label" class="block text-[15px] leading-5 font-medium text-gray-brand-900">
        {{ label }}
      </span>
      <span
        v-if="sublabel"
        data-testid="radio-row-sublabel"
        class="block mt-0.5 text-[13px] leading-[18px] text-gray-brand-600"
      >
        {{ sublabel }}
      </span>
    </span>

    <span
      v-if="price"
      data-testid="radio-row-price"
      class="flex-none text-sm leading-5 font-bold text-gray-brand-700 whitespace-nowrap"
    >
      {{ price }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'RadioRow',

  props: {
    label: {
      type: String,
      required: true
    },
    sublabel: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showDivider: {
      type: Boolean,
      default: true
    }
  },

  emits: ['select'],

  methods: {
    select() {
      if (this.disabled) return
      this.$emit('select')
    }
  }
}
</script>
